import axios from "axios";

import { PickupRequestPriority } from "fe-shared-requests/src/types";

import { toPickupRequestPriorityId } from "fe-shared-requests/src/helpers/pickupRequestStatus";

import { PAGE_SIZE } from "consts";
import { PickupRequestsListParams, PickupRequestsListResponse } from "types";

export const getRequests = (
  _queryKey: string,
  requestParams: PickupRequestsListParams,
  page: number | null = 1
): Promise<PickupRequestsListResponse> =>
  axios
    .post<PickupRequestsListResponse>("pickupRequests/getPickupRequests", {
      ...requestParams,
      limit: page === null ? undefined : PAGE_SIZE,
      skip: page === null ? 0 : (page - 1) * PAGE_SIZE,
    })
    .then((res) => res.data);

export default getRequests;

export const updatePickupRequestPriority = ({
  requestNumber,
  priority,
}: {
  requestNumber: string;
  priority: PickupRequestPriority;
}): Promise<void> =>
  axios
    .put(`pickupRequests/${requestNumber}/priority`, {
      priority: toPickupRequestPriorityId(priority),
    })
    .then(() => undefined);
